export enum CostListOwnerType {
  Doctor = "doctor",
  Supplier = "supplier",
}
